// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/svg/select-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container.clearfix {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;
}

.main-container {
  min-height: 100vh;
  color: #fff;
}
.main-container .input-container .MuiFormControl-root {
  background-color: transparent !important;
}
.main-container .input-container .MuiFormControl-root > div {
  background-color: #fff !important;
}
.main-container a {
  color: #fff;
}
.main-container .input-container {
  display: grid;
  grid-template-columns: auto;
  padding: 0.625rem;
  gap: 0.938rem 3.75rem;
}

.my-input {
  padding: 0.625rem;
  font-size: 0.75rem;
  border: 1px solid #eaeaea;
  background-color: #f6f6f6;
  border-radius: 0.375rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}

.privacy-policy {
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 0.908rem;
  margin-top: 0.625rem;
  margin-bottom: 1.25rem;
}

.privacy-policy span {
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 0.908rem;
}

.privacy-policy a {
  text-decoration: underline;
}

.dialog-recaptcha {
  display: flex;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.login-section {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 6.75rem);
}
.login-section .login-container {
  background-color: rgba(212, 212, 212, 0.1019607843);
  opacity: 1;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 20px;
  padding: 2.5rem 4rem;
  box-shadow: 0 0 0.25rem 0 rgba(0, 0, 0, 0.2509803922);
  position: relative;
  z-index: 1;
  color: #fff;
  width: 35.94vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 3rem;
}
.login-section .login-container .heading {
  margin-top: 2rem;
}
.login-section .login-container .spinner-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-section .login-container .spinner-wrapper .spinner {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.login-section .login-container form {
  width: 75%;
  text-align: center;
}
.login-section .login-container .MuiFormHelperText-root.Mui-error {
  font-size: 11px;
  margin: 0.25rem;
  color: #fff;
}
.login-section .login-container .MuiFormControl-root {
  width: 100%;
}
.login-section .login-container .MuiInputAdornment-root {
  margin-right: -0.65rem;
}
.login-section .login-container .MuiOutlinedInput-root {
  border-radius: 6px;
}
.login-section .login-container .MuiTextField-root {
  border: none;
  box-shadow: none !important;
}
.login-section .login-container .MuiInputBase-root {
  box-shadow: none;
}
.login-section .login-container .MuiInputBase-root fieldset.MuiOutlinedInput-notchedOutline,
.login-section .login-container .MuiInputBase-root:hover fieldset.MuiOutlinedInput-notchedOutline {
  border: 1px solid #eaeaea;
}
.login-section .login-container .input-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
  padding: 0.625rem 0;
}
.login-section .login-container .set-pwd input {
  padding: 0.5rem;
}
.login-section .login-container .my-input svg path {
  stroke: #ffffff;
  stroke-width: 0.047rem;
}
.login-section .login-container .forgot-pwd {
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 0.908rem;
  margin-bottom: 0.625rem;
}
.login-section .login-container .forgot-pwd span {
  font-weight: 700;
}
.login-section .login-container .dialog-submit-container {
  margin-top: 1rem;
  text-align: center;
}
.login-section .login-container .dialog-input-container div {
  width: -webkit-fill-available;
}
.login-section .login-container .link {
  text-decoration: underline;
}
.login-section .login-container .heading {
  font-size: 1.125rem;
  font-weight: 800;
  line-height: 1.924rem;
}
.login-section .login-container .sub-heading {
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.148rem;
  margin-bottom: 1.5rem;
}
.login-section .login-container .sub-heading span Link {
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.148rem;
  color: #EE3A24;
}

.email-exists-section {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: calc(100vh - 6.75rem);
  width: 100%;
}
.email-exists-section .heading {
  font-size: 1.5rem;
  font-weight: 800;
  text-align: center;
}
.email-exists-section .sub-heading span Link {
  color: #EE3A24;
}
.email-exists-section .email-exists-container {
  background-color: rgba(212, 212, 212, 0.1019607843);
  opacity: 1;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 20px;
  padding: 2.5rem 4rem;
  box-shadow: 0 0 0.25rem 0 rgba(0, 0, 0, 0.2509803922);
  position: relative;
  z-index: 1;
  color: #fff;
  padding: 5.5rem 3.5rem;
}
.email-exists-section .email-exists-container .dialog-submit-container {
  text-align: center;
}
.email-exists-section .email-exists-container .login-btn {
  margin-top: 1.5rem;
}
.email-exists-section .email-exists-container .dialog-input-container {
  display: grid;
  grid-template-columns: auto;
  padding: 0.625rem;
  gap: 0.938rem 3.75rem;
}
.email-exists-section .email-exists-container .dialog-input-container input[type=number]::-webkit-inner-spin-button,
.email-exists-section .email-exists-container .dialog-input-container input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.signup-section {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  margin-top: 2.5%;
}
.signup-section .heading {
  font-size: 1.125rem;
  line-height: 1.924rem;
  font-weight: 800;
}
.signup-section .sub-heading span Link {
  color: #EE3A24;
}
.signup-section .contact_container {
  display: flex;
}
.signup-section .contact {
  display: flex;
  flex-direction: column;
}
.signup-section .country-code {
  width: auto;
  margin: 0 1rem 0 0;
}
.signup-section .country-code select {
  max-height: 10vw;
  overflow: auto;
}
.signup-section .phn-no {
  width: 100%;
}
.signup-section .contact select,
.signup-section .phn-no .my-input {
  width: 100%;
  appearance: none;
}
.signup-section .contact_container {
  width: 100%;
}
.signup-section .contact .my-input {
  width: 94%;
}
.signup-section .contact select.my-input {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-color: #f6f6f6;
}
.signup-section .contact select.my-input {
  background-size: 0.754rem;
  background-position: calc(100% - 0.125rem) 0.875rem;
  background-repeat: no-repeat;
}
.signup-section #country_code {
  width: 100%;
  padding: 0.625rem;
  margin-right: 1.5rem;
  font-size: 0.75rem;
}
.signup-section .contact input {
  width: 100%;
}
.signup-section .signup-container {
  background-color: rgba(212, 212, 212, 0.1019607843);
  opacity: 1;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 20px;
  padding: 2.5rem 4rem;
  box-shadow: 0 0 0.25rem 0 rgba(0, 0, 0, 0.2509803922);
  position: relative;
  z-index: 1;
  color: #fff;
  width: 33.44vw;
  padding: 2.5rem 4rem;
}
.signup-section .signup-container .dialog-submit-container {
  text-align: center;
}
.signup-section .signup-container .login-btn {
  margin-top: 1.5rem;
}
.signup-section .signup-container .spinner-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.signup-section .signup-container .spinner-wrapper .spinner {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.signup-section .signup-container .dialog-input-container .inputDivContainer {
  margin-top: 15px;
}
.signup-section .signup-container .dialog-input-container {
  grid-template-columns: auto;
  padding: 0.625rem;
  gap: 0.938rem 3.75rem;
}
.signup-section .signup-container .dialog-input-container input[type=number]::-webkit-inner-spin-button,
.signup-section .signup-container .dialog-input-container input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.signup-section .signup-container .dialog-input-container input[type=number] {
  appearance: textfield;
}
.signup-section .signup-container .dialog-input-container .error {
  font-size: 11px;
  margin: 0.25rem;
}
.signup-section .signup-container .dialog-input-container .row {
  display: flex;
  grid-template-columns: 1fr 1fr;
  width: -webkit-fill-available;
  gap: 5%;
  flex-direction: row;
}
.signup-section .signup-container .dialog-input-container .row div {
  width: 47.5%;
}
.signup-section .signup-container .link {
  color: #fff;
  text-decoration: underline;
}
.signup-section .signup-container h1,
.signup-section .signup-container p {
  text-align: center;
}
.signup-section .signup-container .sub-heading {
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1.148rem;
  font-weight: 500;
}
.signup-section .signup-container .sub-heading span {
  font-weight: 700;
}
.signup-section .signup-container .platform select {
  width: 100%;
  appearance: none;
}
.signup-section .signup-container .platform select.my-input {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-color: #f6f6f6;
}
.signup-section .signup-container .platform select.my-input {
  background-size: 0.788rem;
  background-position: calc(100% - 0.25rem) 0.875rem;
  background-repeat: no-repeat;
}

.email-verification-section {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  min-height: calc(100vh - 6.75rem);
}
.email-verification-section .email-verification-container {
  background-color: rgba(212, 212, 212, 0.1019607843);
  opacity: 1;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 20px;
  padding: 2.5rem 4rem;
  box-shadow: 0 0 0.25rem 0 rgba(0, 0, 0, 0.2509803922);
  position: relative;
  z-index: 1;
  color: #fff;
  width: 40.94vw;
  padding: 2.5rem 1rem;
}
.email-verification-section .email-verification-container .header-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
}
.email-verification-section .email-verification-container .error {
  font-size: 11px;
  margin: 0.25rem;
}
.email-verification-section .email-verification-container .return-login a {
  font-size: 0.625rem;
  font-weight: 500;
  line-height: 0.956rem;
  color: #ffffff;
  text-decoration: underline;
}
.email-verification-section .email-verification-container .email-verification-heading {
  padding: 1.5rem 0;
}
.email-verification-section .email-verification-container .email-verification-heading h2 {
  line-height: 2.84715vw;
}
.email-verification-section .email-verification-container .email-verification-heading p {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.53rem;
}
.email-verification-section .email-verification-container .resend-btn {
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.513rem;
  color: #ffffff;
}
.email-verification-section .email-verification-container .timer {
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 0.908rem;
}
.email-verification-section .email-verification-container .footer-container {
  display: flex;
  align-items: center;
  gap: 4rem;
  justify-content: center;
}

.create-password-container {
  background-color: rgba(212, 212, 212, 0.1019607843);
  opacity: 1;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 20px;
  padding: 2.5rem 4rem;
  box-shadow: 0 0 0.25rem 0 rgba(0, 0, 0, 0.2509803922);
  position: relative;
  z-index: 1;
  color: #fff;
  width: 33.44vw;
  margin: 3rem auto;
}
.create-password-container .set-passwrd-content {
  padding: 0 2rem;
}
.create-password-container .set-passwrd-content .header-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
}
.create-password-container .set-passwrd-content .error {
  font-size: 11px;
  margin: 0.25rem;
}
.create-password-container .set-passwrd-content .header-container h3 {
  margin-top: 0.5rem;
}
.create-password-container .set-passwrd-content .account-created-header {
  text-align: center;
  padding: 1rem;
}
.create-password-container .set-passwrd-content .main-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.create-password-container .set-passwrd-content .main-section .set-pwd input {
  padding: 0.5rem;
}
.create-password-container .set-passwrd-content .main-section .my-input svg path {
  stroke: #ffffff;
  stroke-width: 0.047rem;
}
.create-password-container .set-passwrd-content .check-circle.checked path {
  opacity: 1;
}
.create-password-container .set-passwrd-content .MuiInputAdornment-root {
  margin-right: -0.65rem;
}
.create-password-container .set-passwrd-content .MuiTextField-root {
  border: none;
  box-shadow: none !important;
}
.create-password-container .set-passwrd-content .MuiInputBase-root {
  box-shadow: none;
}
.create-password-container .set-passwrd-content .MuiInputBase-root fieldset.MuiOutlinedInput-notchedOutline,
.create-password-container .set-passwrd-content .MuiInputBase-root:hover fieldset.MuiOutlinedInput-notchedOutline {
  border: 1px solid #ababab;
}
.create-password-container .set-passwrd-content .passwrd-validation {
  margin: 1rem 0;
}
.create-password-container .set-passwrd-content .validation-container {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-size: 0.563rem;
  font-weight: 400;
  line-height: 0.681rem;
}
.create-password-container .set-passwrd-content .validation-container svg path {
  opacity: 0.3;
  fill: #fff;
}
.create-password-container .set-passwrd-content .CTA-section {
  margin-top: 1.5rem;
  text-align: center;
}
.create-password-container .set-passwrd-content .CTA-section button {
  font-size: 0.938rem;
  font-weight: 600;
  line-height: 1.134rem;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 0.047rem solid #ffffff;
}

.account-created-container {
  background-color: rgba(212, 212, 212, 0.1019607843);
  opacity: 1;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 20px;
  padding: 2.5rem 4rem;
  box-shadow: 0 0 0.25rem 0 rgba(0, 0, 0, 0.2509803922);
  position: relative;
  z-index: 1;
  color: #fff;
  width: 43.44vw;
  height: 25.476rem;
  margin: 0 auto;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(212, 212, 212, 0.1019607843);
  border-image-source: linear-gradient(143.81deg, rgba(255, 255, 255, 0.5) 1.54%, rgba(255, 255, 255, 0) 90.23%), linear-gradient(129.65deg, rgba(255, 255, 255, 0) 1.99%, rgba(255, 255, 255, 0.1) 106.61%);
  padding: 0;
}
.account-created-container form {
  height: 100%;
  padding: 2.5rem !important;
}
.account-created-container form h2 {
  padding: 1rem 0;
}
.account-created-container .error {
  font-size: 11px;
  margin: 0.25rem;
}
.account-created-container .close-dialog-icon-button {
  position: relative;
  right: -1.5rem;
}
.account-created-container .MuiFormControl-root {
  width: 100%;
}
.account-created-container .MuiTextField-root {
  border: none;
  box-shadow: none !important;
}
.account-created-container .MuiInputBase-root {
  box-shadow: none;
}
.account-created-container .MuiInputBase-root fieldset.MuiOutlinedInput-notchedOutline,
.account-created-container .MuiInputBase-root:hover fieldset.MuiOutlinedInput-notchedOutline {
  border: 1px solid #ababab;
}
.account-created-container .email-not-found-content {
  margin: 3rem 0;
}
.account-created-container .email-not-found button {
  padding: 0rem 4rem;
}
.account-created-container .email-not-found-heading {
  padding: 1.5rem 0;
}
.account-created-container .email-not-found-heading p {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.53rem;
}
.account-created-container .set-pwd input {
  padding: 0.5rem;
}
.account-created-container .common-input-field {
  width: 100%;
}
.account-created-container .footer-container button {
  border-radius: 0.375rem;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.513rem;
  border: 0.047rem solid #ffffff;
  background: rgba(255, 255, 255, 0.2);
  padding: 1rem;
  height: 3.714rem;
  margin: 0.5rem 0;
}
.account-created-container .return-login a {
  font-size: 0.625rem;
  font-weight: 500;
  line-height: 0.956rem;
  color: #ffffff;
  text-decoration: underline;
}

.account-created-section {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 6.75rem);
}
.account-created-section .account-created-content {
  background-color: rgba(212, 212, 212, 0.1019607843);
  opacity: 1;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 20px;
  padding: 2.5rem 4rem;
  box-shadow: 0 0 0.25rem 0 rgba(0, 0, 0, 0.2509803922);
  position: relative;
  z-index: 1;
  color: #fff;
  text-align: center;
  width: 38.44vw;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(212, 212, 212, 0.1019607843);
  border-image-source: linear-gradient(143.81deg, rgba(255, 255, 255, 0.5) 1.54%, rgba(255, 255, 255, 0) 90.23%), linear-gradient(129.65deg, rgba(255, 255, 255, 0) 1.99%, rgba(255, 255, 255, 0.1) 106.61%);
  padding: 0rem 2rem;
}
.account-created-section .account-created-content .header-container {
  padding: 2rem 1rem;
}
.account-created-section .account-created-content .account-created-heading {
  padding: 1.5rem 0 0;
}
.account-created-section .account-created-content .account-created-heading p {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.53rem;
}
.account-created-section .account-created-content .close-dialog-icon-button {
  position: relative;
  right: -1.5rem;
}
.account-created-section .account-created-content .email-not-found-content {
  margin: 3rem 0;
}
.account-created-section .account-created-content .email-not-found button {
  padding: 0rem 4rem;
}
.account-created-section .account-created-content .email-not-found-heading {
  padding: 1.5rem 0;
}
.account-created-section .account-created-content .email-not-found-heading p {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.53rem;
}
.account-created-section .account-created-content .set-pwd input {
  padding: 0.5rem;
}
.account-created-section .account-created-content .common-input-field {
  width: 100%;
}
.account-created-section .account-created-content .footer-container button {
  border-radius: 0.375rem;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.513rem;
  border: 0.047rem solid #ffffff;
  background: rgba(255, 255, 255, 0.2);
  padding: 1rem;
  height: 3.714rem;
  margin: 0.5rem 0;
}
.account-created-section .account-created-content .return-login a {
  font-size: 0.625rem;
  font-weight: 500;
  line-height: 0.956rem;
  color: #ffffff;
  text-decoration: underline;
}

.email-not-found-container {
  background-color: rgba(212, 212, 212, 0.1019607843);
  opacity: 1;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 20px;
  padding: 2.5rem 4rem;
  box-shadow: 0 0 0.25rem 0 rgba(0, 0, 0, 0.2509803922);
  position: relative;
  z-index: 1;
  color: #fff;
  width: 38.44vw;
  margin: 0 auto;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(212, 212, 212, 0.1019607843);
  border-image-source: linear-gradient(143.81deg, rgba(255, 255, 255, 0.5) 1.54%, rgba(255, 255, 255, 0) 90.23%), linear-gradient(129.65deg, rgba(255, 255, 255, 0) 1.99%, rgba(255, 255, 255, 0.1) 106.61%);
  padding: 3.5rem 2rem;
}
.email-not-found-container .close-dialog-icon-button {
  position: relative;
  right: -1.5rem;
}
.email-not-found-container .error {
  font-size: 11px;
  margin: 0.25rem;
}
.email-not-found-container .email-not-found-heading {
  padding: 1.5rem 0;
}
.email-not-found-container .email-not-found-heading p {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.53rem;
}
.email-not-found-container .footer-container button {
  border-radius: 0.375rem;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.513rem;
  border: 0.047rem solid #ffffff;
  background: rgba(255, 255, 255, 0.2);
  padding: 1rem 3rem;
  height: 3.714rem;
  margin: 0.5rem 0;
}
.email-not-found-container .return-login a {
  font-size: 0.625rem;
  font-weight: 500;
  line-height: 0.956rem;
  color: #ffffff;
  text-decoration: underline;
}

header.sigupHeader nav {
  width: 100%;
  max-width: 100%;
  padding-left: 24px;
  padding-top: 20px;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/style/components/LoginSignup.scss","webpack://./src/style/_colors.scss"],"names":[],"mappings":"AAoBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE,iBAAA;EACA,WCzBa;ADMf;AAqBE;EACE,wCAAA;AAnBJ;AAqBE;EACE,iCAAA;AAnBJ;AAsBE;EACE,WCnCW;ADef;AAuBE;EACE,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,qBAAA;AArBJ;;AAyBA;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gDAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,sBAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;AAtBF;;AAyBA;EACE,0BAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;AAtBF;AAwBE;EAxFA,mDAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,oBAAA;EACA,qDAAA;EACA,kBAAA;EACA,UAAA;EACA,WCPa;EDyFX,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAdJ;AAgBI;EACE,gBAAA;AAdN;AAgBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAdN;AAeM;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAbR;AAgBI;EACE,UAAA;EACA,kBAAA;AAdN;AAgBI;EACE,eAAA;EACA,eAAA;EACA,WAAA;AAdN;AAgBI;EACE,WAAA;AAdN;AAgBI;EACE,sBAAA;AAdN;AAgBI;EACE,kBAAA;AAdN;AAgBI;EACE,YAAA;EACA,2BAAA;AAdN;AAgBI;EACE,gBAAA;AAdN;AAiBI;;EAEE,yBAAA;AAfN;AAkBI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,eAAA;AAjBN;AAoBI;EACE,eAAA;EACA,sBAAA;AAlBN;AAqBI;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;AAnBN;AAsBI;EACE,gBAAA;AApBN;AAuBI;EACE,gBAAA;EACA,kBAAA;AArBN;AAwBI;EACE,6BAAA;AAtBN;AAyBI;EACE,0BAAA;AAvBN;AA0BI;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;AAxBN;AA2BI;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AAzBN;AA4BI;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cC5MU;ADkLhB;;AA+BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,iCAAA;EACA,WAAA;AA5BF;AA6BE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AA3BJ;AA8BE;EACE,cC/NY;ADmMhB;AA8BE;EA9NA,mDAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,oBAAA;EACA,qDAAA;EACA,kBAAA;EACA,UAAA;EACA,WCPa;ED+NX,sBAAA;AApBJ;AAqBI;EACE,kBAAA;AAnBN;AAsBI;EACE,kBAAA;AApBN;AAuBI;EACE,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,qBAAA;AArBN;AAuBM;;EAEE,wBAAA;EACA,SAAA;AArBR;;AA0BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAvBF;AAyBE;EACE,mBAAA;EACA,qBAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,cCzQY;ADiPhB;AA0BE;EACE,aAAA;AAxBJ;AA0BE;EACE,aAAA;EACA,sBAAA;AAxBJ;AA0BE;EACE,WAAA;EACA,kBAAA;AAxBJ;AA0BE;EACE,gBAAA;EACA,cAAA;AAxBJ;AA0BE;EACE,WAAA;AAxBJ;AA2BE;;EAEE,WAAA;EAGA,gBAAA;AAzBJ;AA2BE;EACE,WAAA;AAzBJ;AA2BE;EACE,UAAA;AAzBJ;AA4BE;EACE,6DAAA;EACA,yBAAA;AA1BJ;AA6BE;EACE,yBAAA;EACA,mDAAA;EACA,4BAAA;AA3BJ;AA8BE;EACE,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AA5BJ;AA+BE;EACE,WAAA;AA7BJ;AAgCE;EA/TA,mDAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,oBAAA;EACA,qDAAA;EACA,kBAAA;EACA,UAAA;EACA,WCPa;EDgUX,cAAA;EACA,oBAAA;AAtBJ;AAwBI;EACE,kBAAA;AAtBN;AAyBI;EACE,kBAAA;AAvBN;AAyBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvBN;AAwBM;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAtBR;AAyBI;EACE,gBAAA;AAvBN;AAyBI;EACE,2BAAA;EACA,iBAAA;EACA,qBAAA;AAvBN;AAyBM;;EAEE,wBAAA;EACA,SAAA;AAvBR;AA0BM;EAEE,qBAAA;AAxBR;AA2BM;EACE,eAAA;EACA,eAAA;AAzBR;AA2BM;EACE,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,OAAA;EACA,mBAAA;AAzBR;AA2BM;EACE,YAAA;AAzBR;AA6BI;EACE,WC5XS;ED6XT,0BAAA;AA3BN;AA8BI;;EAEE,kBAAA;AA5BN;AA+BI;EACE,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AA7BN;AA+BI;EACE,gBAAA;AA7BN;AA+BI;EACE,WAAA;EAGA,gBAAA;AA7BN;AAgCI;EACE,6DAAA;EACA,yBAAA;AA9BN;AAiCI;EACE,yBAAA;EACA,kDAAA;EACA,4BAAA;AA/BN;;AAoCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,iCAAA;AAjCF;AAmCE;EA3aA,mDAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,oBAAA;EACA,qDAAA;EACA,kBAAA;EACA,UAAA;EACA,WCPa;ED4aX,cAAA;EACA,oBAAA;AAzBJ;AA2BI;EApaF,aAAA;EACA,sBAAA;EACA,mBAAA;EAoaI,WAAA;EACA,kBAAA;AAvBN;AAyBI;EACE,eAAA;EACA,eAAA;AAvBN;AAyBI;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,0BAAA;AAvBN;AA0BI;EACE,iBAAA;AAxBN;AA0BI;EACE,sBAAA;AAxBN;AA0BI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AAxBN;AA0BI;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AAxBN;AA0BI;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;AAxBN;AA0BI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;AAxBN;;AA6BA;EAheE,mDAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,oBAAA;EACA,qDAAA;EACA,kBAAA;EACA,UAAA;EACA,WCPa;EDieb,cAAA;EACA,iBAAA;AAlBF;AAoBE;EACE,eAAA;AAlBJ;AAoBI;EA5dF,aAAA;EACA,sBAAA;EACA,mBAAA;EA4dI,mBAAA;AAhBN;AAkBI;EACE,eAAA;EACA,eAAA;AAhBN;AAkBI;EACE,kBAAA;AAhBN;AAmBI;EACE,kBAAA;EACA,aAAA;AAjBN;AAoBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAlBN;AAoBM;EACE,eAAA;AAlBR;AAqBM;EACE,eAAA;EACA,sBAAA;AAnBR;AAuBI;EACE,UAAA;AArBN;AAuBI;EACE,sBAAA;AArBN;AAuBI;EACE,YAAA;EACA,2BAAA;AArBN;AAuBI;EACE,gBAAA;AArBN;AAuBI;;EAEE,yBAAA;AArBN;AAuBI;EACE,cAAA;AArBN;AAuBI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AArBN;AAuBM;EACE,YAAA;EACA,UAAA;AArBR;AAyBI;EACE,kBAAA;EACA,kBAAA;AAvBN;AA0BI;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oCAAA;EACA,WAAA;EACA,8BAAA;AAxBN;;AA6BA;EA1jBE,mDAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,oBAAA;EACA,qDAAA;EACA,kBAAA;EACA,UAAA;EACA,WCPa;ED2jBb,cAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EAEA,2CAAA;EACA,6CAAA;EACA,0MAAA;EAWA,UAAA;AA7BF;AA+BE;EACE,YAAA;EACA,0BAAA;AA7BJ;AAgCE;EACE,eAAA;AA9BJ;AAgCE;EACE,eAAA;EACA,eAAA;AA9BJ;AAgCE;EACE,kBAAA;EACA,cAAA;AA9BJ;AAiCE;EACE,WAAA;AA/BJ;AAiCE;EACE,YAAA;EACA,2BAAA;AA/BJ;AAiCE;EACE,gBAAA;AA/BJ;AAiCE;;EAEE,yBAAA;AA/BJ;AAiCE;EACE,cAAA;AA/BJ;AAkCE;EACE,kBAAA;AAhCJ;AAmCE;EACE,iBAAA;AAjCJ;AAoCE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AAlCJ;AAqCE;EACE,eAAA;AAnCJ;AAsCE;EACE,WAAA;AApCJ;AAuCE;EACE,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,8BAAA;EACA,oCAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AArCJ;AAwCE;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,0BAAA;AAtCJ;;AA0CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;AAvCF;AAyCE;EAtqBA,mDAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,oBAAA;EACA,qDAAA;EACA,kBAAA;EACA,UAAA;EACA,WCPa;EDuqBX,kBAAA;EACA,cAAA;EACA,2CAAA;EACA,6CAAA;EACA,0MAAA;EAWA,kBAAA;AAzCJ;AA2CI;EACE,kBAAA;AAzCN;AA4CI;EACE,mBAAA;AA1CN;AA6CI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AA3CN;AA8CI;EACE,kBAAA;EACA,cAAA;AA5CN;AA+CI;EACE,cAAA;AA7CN;AAgDI;EACE,kBAAA;AA9CN;AAiDI;EACE,iBAAA;AA/CN;AAkDI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AAhDN;AAmDI;EACE,eAAA;AAjDN;AAoDI;EACE,WAAA;AAlDN;AAqDI;EACE,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,8BAAA;EACA,oCAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAnDN;AAsDI;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,0BAAA;AApDN;;AAyDA;EA5vBE,mDAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,oBAAA;EACA,qDAAA;EACA,kBAAA;EACA,UAAA;EACA,WCPa;ED6vBb,cAAA;EACA,cAAA;EACA,kBAAA;EAEA,2CAAA;EACA,6CAAA;EACA,0MAAA;EAWA,oBAAA;AAzDF;AA2DE;EACE,kBAAA;EACA,cAAA;AAzDJ;AA4DE;EACE,eAAA;EACA,eAAA;AA1DJ;AA4DE;EACE,iBAAA;AA1DJ;AA6DE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AA3DJ;AA8DE;EACE,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,8BAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA5DJ;AA+DE;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,0BAAA;AA7DJ;;AAiEA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;AA9DF","sourcesContent":["@import \"../colors\";\n\n@mixin generic-container {\n  background-color: #d4d4d41a;\n  opacity: 1;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  border-radius: 20px;\n  padding: 2.5rem 4rem;\n  box-shadow: 0 0 0.25rem 0 #00000040;\n  position: relative;\n  z-index: 1;\n  color: $color_white;\n}\n\n@mixin header-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.main-container.clearfix {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.5rem;\n}\n\n.main-container {\n  min-height: 100vh;\n  color: $color_white;\n\n  .input-container .MuiFormControl-root {\n    background-color: transparent !important;\n  }\n  .input-container .MuiFormControl-root > div {\n    background-color: $color_white !important;\n  }\n\n  a {\n    color: $color_white;\n  }\n\n  .input-container {\n    display: grid;\n    grid-template-columns: auto;\n    padding: 0.625rem;\n    gap: 0.938rem 3.75rem;\n  }\n}\n\n.my-input {\n  padding: 0.625rem;\n  font-size: 0.75rem;\n  border: 1px solid #eaeaea;\n  background-color: #f6f6f6;\n  border-radius: 0.375rem;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n\n.privacy-policy {\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 0.908rem;\n  margin-top: 0.625rem;\n  margin-bottom: 1.25rem;\n}\n\n.privacy-policy span {\n  font-size: 0.75rem;\n  font-weight: 700;\n  line-height: 0.908rem;\n}\n\n.privacy-policy a {\n  text-decoration: underline;\n}\n\n.dialog-recaptcha {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1.25rem;\n}\n\n.login-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  min-height: calc(100vh - 6.75rem);\n\n  .login-container {\n    @include generic-container;\n    width: 35.94vw;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 1rem 3rem;\n\n    .heading {\n      margin-top: 2rem;\n    }\n    .spinner-wrapper {\n      position: relative;\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      .spinner {\n        position: fixed;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n      }\n    }\n    form {\n      width: 75%;\n      text-align: center;\n    }\n    .MuiFormHelperText-root.Mui-error {\n      font-size: 11px;\n      margin: 0.25rem;\n      color: #fff;\n    }\n    .MuiFormControl-root {\n      width: 100%;\n    }\n    .MuiInputAdornment-root {\n      margin-right: -0.65rem;\n    }\n    .MuiOutlinedInput-root {\n      border-radius: 6px;\n    }\n    .MuiTextField-root {\n      border: none;\n      box-shadow: none !important;\n    }\n    .MuiInputBase-root {\n      box-shadow: none;\n    }\n\n    .MuiInputBase-root fieldset.MuiOutlinedInput-notchedOutline,\n    .MuiInputBase-root:hover fieldset.MuiOutlinedInput-notchedOutline {\n      border: 1px solid #eaeaea;\n    }\n\n    .input-container {\n      display: flex;\n      flex-direction: column;\n      margin-bottom: 0.5rem;\n      padding: 0.625rem 0;\n    }\n\n    .set-pwd input {\n      padding: 0.5rem;\n    }\n\n    .my-input svg path {\n      stroke: #ffffff;\n      stroke-width: 0.047rem;\n    }\n\n    .forgot-pwd {\n      font-size: 0.75rem;\n      font-weight: 400;\n      line-height: 0.908rem;\n      margin-bottom: 0.625rem;\n    }\n\n    .forgot-pwd span {\n      font-weight: 700;\n    }\n\n    .dialog-submit-container {\n      margin-top: 1rem;\n      text-align: center;\n    }\n\n    .dialog-input-container div {\n      width: -webkit-fill-available;\n    }\n\n    .link {\n      text-decoration: underline;\n    }\n\n    .heading {\n      font-size: 1.125rem;\n      font-weight: 800;\n      line-height: 1.924rem;\n    }\n\n    .sub-heading {\n      font-size: 0.75rem;\n      font-weight: 500;\n      line-height: 1.148rem;\n      margin-bottom: 1.5rem;\n    }\n\n    .sub-heading span Link {\n      font-size: 0.75rem;\n      font-weight: 700;\n      line-height: 1.148rem;\n      color: $primary-color;\n    }\n  }\n}\n\n.email-exists-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  min-height: calc(100vh - 6.75rem);\n  width: 100%;\n  .heading {\n    font-size: 1.5rem;\n    font-weight: 800;\n    text-align: center;\n  }\n\n  .sub-heading span Link {\n    color: $primary-color;\n  }\n  .email-exists-container {\n    @include generic-container;\n    padding: 5.5rem 3.5rem;\n    .dialog-submit-container {\n      text-align: center;\n    }\n\n    .login-btn {\n      margin-top: 1.5rem;\n    }\n\n    .dialog-input-container {\n      display: grid;\n      grid-template-columns: auto;\n      padding: 0.625rem;\n      gap: 0.938rem 3.75rem;\n\n      input[type=\"number\"]::-webkit-inner-spin-button,\n      input[type=\"number\"]::-webkit-outer-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n    }\n  }\n}\n.signup-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  margin-top: 2.5%;\n\n  .heading {\n    font-size: 1.125rem;\n    line-height: 1.924rem;\n    font-weight: 800;\n  }\n\n  .sub-heading span Link {\n    color: $primary-color;\n  }\n  .contact_container {\n    display: flex;\n  }\n  .contact {\n    display: flex;\n    flex-direction: column;\n  }\n  .country-code {\n    width: auto;\n    margin: 0 1rem 0 0;\n  }\n  .country-code select {\n    max-height: 10vw;\n    overflow: auto;\n  }\n  .phn-no {\n    width: 100%;\n  }\n\n  .contact select,\n  .phn-no .my-input {\n    width: 100%;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n  }\n  .contact_container {\n    width: 100%;\n  }\n  .contact .my-input {\n    width: 94%;\n  }\n\n  .contact select.my-input {\n    background: url(\"../../assets/svg/select-arrow.svg\") no-repeat;\n    background-color: #f6f6f6;\n  }\n\n  .contact select.my-input {\n    background-size: 0.754rem;\n    background-position: calc(100% - 0.125rem) 0.875rem;\n    background-repeat: no-repeat;\n  }\n\n  #country_code {\n    width: 100%;\n    padding: 0.625rem;\n    margin-right: 1.5rem;\n    font-size: 0.75rem;\n  }\n\n  .contact input {\n    width: 100%;\n  }\n\n  .signup-container {\n    @include generic-container;\n    width: 33.44vw;\n    padding: 2.5rem 4rem;\n\n    .dialog-submit-container {\n      text-align: center;\n    }\n\n    .login-btn {\n      margin-top: 1.5rem;\n    }\n    .spinner-wrapper {\n      position: relative;\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      .spinner {\n        position: fixed;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n      }\n    }\n    .dialog-input-container .inputDivContainer {\n      margin-top: 15px;\n    }\n    .dialog-input-container {\n      grid-template-columns: auto;\n      padding: 0.625rem;\n      gap: 0.938rem 3.75rem;\n\n      input[type=\"number\"]::-webkit-inner-spin-button,\n      input[type=\"number\"]::-webkit-outer-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n\n      input[type=\"number\"] {\n        -moz-appearance: textfield;\n        appearance: textfield;\n      }\n\n      .error {\n        font-size: 11px;\n        margin: 0.25rem;\n      }\n      .row {\n        display: flex;\n        grid-template-columns: 1fr 1fr;\n        width: -webkit-fill-available;\n        gap: 5%;\n        flex-direction: row;\n      }\n      .row div {\n        width: 47.5%;\n      }\n    }\n\n    .link {\n      color: $color_white;\n      text-decoration: underline;\n    }\n\n    h1,\n    p {\n      text-align: center;\n    }\n\n    .sub-heading {\n      margin-bottom: 0.5rem;\n      font-size: 0.75rem;\n      line-height: 1.148rem;\n      font-weight: 500;\n    }\n    .sub-heading span {\n      font-weight: 700;\n    }\n    .platform select {\n      width: 100%;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n    }\n\n    .platform select.my-input {\n      background: url(\"../../assets/svg/select-arrow.svg\") no-repeat;\n      background-color: #f6f6f6;\n    }\n\n    .platform select.my-input {\n      background-size: 0.788rem;\n      background-position: calc(100% - 0.25rem) 0.875rem;\n      background-repeat: no-repeat;\n    }\n  }\n}\n\n.email-verification-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  min-height: calc(100vh - 6.75rem);\n\n  .email-verification-container {\n    @include generic-container;\n    width: 40.94vw;\n    padding: 2.5rem 1rem;\n\n    .header-container {\n      @include header-container;\n      gap: 0.5rem;\n      text-align: center;\n    }\n    .error {\n      font-size: 11px;\n      margin: 0.25rem;\n    }\n    .return-login a {\n      font-size: 0.625rem;\n      font-weight: 500;\n      line-height: 0.956rem;\n      color: #ffffff;\n      text-decoration: underline;\n    }\n\n    .email-verification-heading {\n      padding: 1.5rem 0;\n    }\n    .email-verification-heading h2 {\n      line-height: 2.84715vw;\n    }\n    .email-verification-heading p {\n      font-size: 1rem;\n      font-weight: 500;\n      line-height: 1.53rem;\n    }\n    .resend-btn {\n      font-size: 1.25rem;\n      font-weight: 600;\n      line-height: 1.513rem;\n      color: #ffffff;\n    }\n    .timer {\n      font-size: 0.75rem;\n      font-weight: 500;\n      line-height: 0.908rem;\n    }\n    .footer-container {\n      display: flex;\n      align-items: center;\n      gap: 4rem;\n      justify-content: center;\n    }\n  }\n}\n\n.create-password-container {\n  @include generic-container;\n  width: 33.44vw;\n  margin: 3rem auto;\n\n  .set-passwrd-content {\n    padding: 0 2rem;\n\n    .header-container {\n      @include header-container;\n      margin-bottom: 2rem;\n    }\n    .error {\n      font-size: 11px;\n      margin: 0.25rem;\n    }\n    .header-container h3 {\n      margin-top: 0.5rem;\n    }\n\n    .account-created-header {\n      text-align: center;\n      padding: 1rem;\n    }\n\n    .main-section {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n\n      .set-pwd input {\n        padding: 0.5rem;\n      }\n\n      .my-input svg path {\n        stroke: #ffffff;\n        stroke-width: 0.047rem;\n      }\n    }\n\n    .check-circle.checked path {\n      opacity: 1;\n    }\n    .MuiInputAdornment-root {\n      margin-right: -0.65rem;\n    }\n    .MuiTextField-root {\n      border: none;\n      box-shadow: none !important;\n    }\n    .MuiInputBase-root {\n      box-shadow: none;\n    }\n    .MuiInputBase-root fieldset.MuiOutlinedInput-notchedOutline,\n    .MuiInputBase-root:hover fieldset.MuiOutlinedInput-notchedOutline {\n      border: 1px solid #ababab;\n    }\n    .passwrd-validation {\n      margin: 1rem 0;\n    }\n    .validation-container {\n      display: flex;\n      align-items: center;\n      gap: 0.7rem;\n      font-size: 0.563rem;\n      font-weight: 400;\n      line-height: 0.681rem;\n\n      svg path {\n        opacity: 0.3;\n        fill: #fff;\n      }\n    }\n\n    .CTA-section {\n      margin-top: 1.5rem;\n      text-align: center;\n    }\n\n    .CTA-section button {\n      font-size: 0.938rem;\n      font-weight: 600;\n      line-height: 1.134rem;\n      background: #ffffff33;\n      color: #fff;\n      border: 0.047rem solid #ffffff;\n    }\n  }\n}\n\n.account-created-container {\n  @include generic-container;\n  width: 43.44vw;\n  height: 25.476rem;\n  margin: 0 auto;\n  text-align: center;\n\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  background: #d4d4d41a;\n  border-image-source: linear-gradient(\n      143.81deg,\n      rgba(255, 255, 255, 0.5) 1.54%,\n      rgba(255, 255, 255, 0) 90.23%\n    ),\n    linear-gradient(\n      129.65deg,\n      rgba(255, 255, 255, 0) 1.99%,\n      rgba(255, 255, 255, 0.1) 106.61%\n    );\n\n  padding: 0;\n\n  form {\n    height: 100%;\n    padding: 2.5rem !important;\n  }\n\n  form h2 {\n    padding: 1rem 0;\n  }\n  .error {\n    font-size: 11px;\n    margin: 0.25rem;\n  }\n  .close-dialog-icon-button {\n    position: relative;\n    right: -1.5rem;\n  }\n\n  .MuiFormControl-root {\n    width: 100%;\n  }\n  .MuiTextField-root {\n    border: none;\n    box-shadow: none !important;\n  }\n  .MuiInputBase-root {\n    box-shadow: none;\n  }\n  .MuiInputBase-root fieldset.MuiOutlinedInput-notchedOutline,\n  .MuiInputBase-root:hover fieldset.MuiOutlinedInput-notchedOutline {\n    border: 1px solid #ababab;\n  }\n  .email-not-found-content {\n    margin: 3rem 0;\n  }\n\n  .email-not-found button {\n    padding: 0rem 4rem;\n  }\n\n  .email-not-found-heading {\n    padding: 1.5rem 0;\n  }\n\n  .email-not-found-heading p {\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1.53rem;\n  }\n\n  .set-pwd input {\n    padding: 0.5rem;\n  }\n\n  .common-input-field {\n    width: 100%;\n  }\n\n  .footer-container button {\n    border-radius: 0.375rem;\n    font-weight: 600;\n    font-size: 1.25rem;\n    line-height: 1.513rem;\n    border: 0.047rem solid #ffffff;\n    background: #ffffff33;\n    padding: 1rem;\n    height: 3.714rem;\n    margin: 0.5rem 0;\n  }\n\n  .return-login a {\n    font-size: 0.625rem;\n    font-weight: 500;\n    line-height: 0.956rem;\n    color: #ffffff;\n    text-decoration: underline;\n  }\n}\n\n.account-created-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  min-height: calc(100vh - 6.75rem);\n\n  .account-created-content {\n    @include generic-container;\n    text-align: center;\n    width: 38.44vw;\n    border: 1px solid rgba(255, 255, 255, 0.35);\n    background: #d4d4d41a;\n    border-image-source: linear-gradient(\n        143.81deg,\n        rgba(255, 255, 255, 0.5) 1.54%,\n        rgba(255, 255, 255, 0) 90.23%\n      ),\n      linear-gradient(\n        129.65deg,\n        rgba(255, 255, 255, 0) 1.99%,\n        rgba(255, 255, 255, 0.1) 106.61%\n      );\n\n    padding: 0rem 2rem;\n\n    .header-container {\n      padding: 2rem 1rem;\n    }\n\n    .account-created-heading {\n      padding: 1.5rem 0 0;\n    }\n\n    .account-created-heading p {\n      font-size: 1rem;\n      font-weight: 500;\n      line-height: 1.53rem;\n    }\n\n    .close-dialog-icon-button {\n      position: relative;\n      right: -1.5rem;\n    }\n\n    .email-not-found-content {\n      margin: 3rem 0;\n    }\n\n    .email-not-found button {\n      padding: 0rem 4rem;\n    }\n\n    .email-not-found-heading {\n      padding: 1.5rem 0;\n    }\n\n    .email-not-found-heading p {\n      font-size: 1rem;\n      font-weight: 500;\n      line-height: 1.53rem;\n    }\n\n    .set-pwd input {\n      padding: 0.5rem;\n    }\n\n    .common-input-field {\n      width: 100%;\n    }\n\n    .footer-container button {\n      border-radius: 0.375rem;\n      font-weight: 600;\n      font-size: 1.25rem;\n      line-height: 1.513rem;\n      border: 0.047rem solid #ffffff;\n      background: #ffffff33;\n      padding: 1rem;\n      height: 3.714rem;\n      margin: 0.5rem 0;\n    }\n\n    .return-login a {\n      font-size: 0.625rem;\n      font-weight: 500;\n      line-height: 0.956rem;\n      color: #ffffff;\n      text-decoration: underline;\n    }\n  }\n}\n\n.email-not-found-container {\n  @include generic-container;\n  width: 38.44vw;\n  margin: 0 auto;\n  text-align: center;\n\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  background: #d4d4d41a;\n  border-image-source: linear-gradient(\n      143.81deg,\n      rgba(255, 255, 255, 0.5) 1.54%,\n      rgba(255, 255, 255, 0) 90.23%\n    ),\n    linear-gradient(\n      129.65deg,\n      rgba(255, 255, 255, 0) 1.99%,\n      rgba(255, 255, 255, 0.1) 106.61%\n    );\n\n  padding: 3.5rem 2rem;\n\n  .close-dialog-icon-button {\n    position: relative;\n    right: -1.5rem;\n  }\n\n  .error {\n    font-size: 11px;\n    margin: 0.25rem;\n  }\n  .email-not-found-heading {\n    padding: 1.5rem 0;\n  }\n\n  .email-not-found-heading p {\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1.53rem;\n  }\n\n  .footer-container button {\n    border-radius: 0.375rem;\n    font-weight: 600;\n    font-size: 1.25rem;\n    line-height: 1.513rem;\n    border: 0.047rem solid #ffffff;\n    background: #ffffff33;\n    padding: 1rem 3rem;\n    height: 3.714rem;\n    margin: 0.5rem 0;\n  }\n\n  .return-login a {\n    font-size: 0.625rem;\n    font-weight: 500;\n    line-height: 0.956rem;\n    color: #ffffff;\n    text-decoration: underline;\n  }\n}\n\nheader.sigupHeader nav {\n  width: 100%;\n  max-width: 100%;\n  padding-left: 24px;\n  padding-top: 20px;\n  margin: 0;\n}\n","$primary-color: #EE3A24;\n$secondary-color: #923D32;\n\n$text_black : #000000;\n$color_white : #fff;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
